import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import HomePage from './components/pages/home/HomePage';
import AboutPage from './components/pages/about/AboutPage';
import DeliveryServicePage from './components/pages/services/DeliveryServicePage';
import JunkRemovalPage from './components/pages/services/JunkRemovalPage';
import JunkRemovalCityPage from './components/pages/junk-removal/JunkRemovalCityPage';
import MovingServicePage from './components/pages/services/MovingServicePage';
import SpecialtyServicesPage from './components/pages/services/SpecialtyServicesPage';
import ServiceAreasPage from './components/pages/areas/ServiceAreasPage';
import PricingPage from './components/pages/pricing/PricingPage';
import FaqPage from './components/pages/faq/FaqPage';
import ContactPage from './components/pages/contact/ContactPage';
import PrivacyPolicyPage from './components/pages/legal/PrivacyPolicyPage';
import TermsOfServicePage from './components/pages/legal/TermsOfServicePage';
import BlogListPage from './components/pages/blog/BlogListPage';
import BlogPostPage from './components/pages/blog/BlogPostPage';
import NotFoundPage from './components/pages/NotFoundPage';
import CookieConsent from './components/common/CookieConsent';
import ScrollToTop from './utils/ScrollToTop';
import { SITE_URL } from './utils/site';

const App: React.FC = () => {
  const { pathname } = useLocation();
  // One canonical address per page (no www, no trailing slash) so Google doesn't see duplicates
  const canonicalUrl = SITE_URL + (pathname === '/' ? '/' : pathname.toLowerCase().replace(/\/+$/, ''));

  return (
    <>
      <Helmet defaultTitle="JBR Delivery LLC - Delivery, Junk Removal & Moving Services in Northeast Wisconsin"
              titleTemplate="%s | JBR Delivery LLC">
        <meta name="description" content="Professional delivery, junk removal, and moving services in Northeast Wisconsin. Fast, reliable, and affordable solutions for all your needs." />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      
      <ScrollToTop />
      <Header />
      
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<Navigate to="/services/delivery" replace />} />
          <Route path="/services/delivery" element={<DeliveryServicePage />} />
          <Route path="/services/junk-removal" element={<JunkRemovalPage />} />
          <Route path="/junk-removal" element={<Navigate to="/services/junk-removal" replace />} />
          <Route path="/junk-removal/:city" element={<JunkRemovalCityPage />} />
          <Route path="/services/moving" element={<MovingServicePage />} />
          <Route path="/services/specialty" element={<SpecialtyServicesPage />} />
          <Route path="/areas" element={<ServiceAreasPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      
      <Footer />
      <CookieConsent />
    </>
  );
};

export default App;
